
<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            Dashboard
        </h4>

        <div class="row">
            <div class="col-lg-8 mb-3 order-0">
                <mat-card style="margin-bottom: 30px;">
                    <div class="d-flex align-items-end row">
                        <div class="col-sm-7">
                            <mat-card-content>
                                <h5>Thank You For Signing With Us !!!</h5>
                                <p class="mb-4">
                                    <span class="fw-bold" style="color:red">Your Account is not activated.
                                    </span><br>
                                    <br>Please complete Business Profile for your account activation.
                                </p>
                            </mat-card-content>
                        </div>
                        <div class="col-sm-5 text-center text-sm-left">
                            <div class="card-body pb-0 px-0 px-md-4">
                                <img src="../assets/img/illustrations/bannerpng.png" height="75%" width="75%"
                                    alt="View Badge User" data-app-dark-img="illustrations/man-with-laptop-dark.png"
                                    data-app-light-img="illustrations/man-with-laptop-light.png">
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>

        <mat-card>
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">person_outline</span>Business Profile &nbsp;
                <div style="display: flex;position: absolute;right: 20px;">
                    <mat-slide-toggle></mat-slide-toggle>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class="row mt-5">
                    <div class="col-md-3">
                        <mat-card>
                            <mat-card-content style="font-size: 16px; text-align: center;">
                                Bank Details <br> <a href="/#/inactiveAll/bankdetails"><mat-icon class="nav-icon"
                                        style="text-align: center;">edit</mat-icon></a>
                                <div class="account" style="padding: 30px;text-align: center; color: red;">
                                    Not Completed
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-md-3">
                        <mat-card>
                            <mat-card-content style="font-size: 16px; text-align: center;">
                                Company Details <br><a href="/#/inactiveAll/companydetails"><mat-icon class="nav-icon"
                                        style="text-align: center;">edit</mat-icon></a>
                                <div class="account" style="padding: 30px;text-align: center; color: red;">
                                    Not Completed
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-md-3">
                        <mat-card>
                            <mat-card-content style="font-size: 16px; text-align: center;">
                                Public Details <br><a href="/#/inactiveAll/publicDetails"><mat-icon class="nav-icon"
                                        style="text-align: center;">edit</mat-icon></a>
                                <div class="account" style="padding: 30px;text-align: center; color: red;">
                                    Not Completed
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-md-3">
                        <mat-card>
                            <mat-card-content style=" font-size: 16px; text-align: center;">
                                Product Details <br><a href="/#/inactiveAll/productSetting"><mat-icon class="nav-icon"
                                        style="text-align: center;">edit</mat-icon></a>
                                <div class="account" style="padding: 30px;text-align: center; color: red;">
                                    Not Completed
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
